import { render, staticRenderFns } from "./appLogo.vue?vue&type=template&id=2c7ae500&scoped=true&"
import script from "./appLogo.vue?vue&type=script&lang=js&"
export * from "./appLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ae500",
  null
  
)

export default component.exports